import React, { useState } from "react";
import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import { DELETE_CONFIRMATION_NO, DELETE_CONFIRMATION_YES, USER_ID_REASSIGN_TEXT } from "../UserVisibleStrings";

type ReassignConfirmationModalProps = {
    open: boolean,
    currentUserId: number | undefined,
    currentTripId: string | undefined,
    onReassign: ( userId: string ) => void,
    onClose: () => void,
};

const ReassignConfirmationModal: React.FC<ReassignConfirmationModalProps> = ( {
    open,
    currentUserId,
    currentTripId,
    onReassign,
    onClose,
} ) =>
{
    const [ userId, setUserId ] = useState( "" );
    const [ confirmStep, setConfirmStep ] = useState( false );

    const handlePrimaryAction = ( event: React.MouseEvent ) =>
    {
        event.stopPropagation();
        if ( !confirmStep )
        {
            setConfirmStep( true );
        }
        else
        {
            onReassign( userId );
            setConfirmStep( false );
        }
    };

    const handleClose = ( event: React.MouseEvent ) =>
    {
        event.stopPropagation();
        setUserId( "" );
        setConfirmStep( false );
        onClose();
    };

    return (
        <Modal open = {open} onClose = {handleClose}>
            <Box
                sx = {{
                    padding: 2,
                    bgcolor: "background.paper",
                    borderRadius: 1,
                    outline: "none",
                    width: 400,
                    margin: "auto",
                    marginTop: "20%",
                }}
                onClick = {( event ) => event.stopPropagation()}
            >
                {!confirmStep ? (
                    <React.Fragment>
                        <Typography variant = "h6">{USER_ID_REASSIGN_TEXT}</Typography>
                        <Typography sx = {{ mt: 1, mb: 2 }}>
                            We do not have access to WordPress IDs on the backend for validation, so make sure to double-check that the value entered here belongs to a user.
                        </Typography>
                        <TextField
                            fullWidth
                            label = "New User ID"
                            value = {userId}
                            onChange = {( event ) => setUserId( event.target.value )}
                            onClick = {( event ) => event.stopPropagation()}
                        />
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Typography variant = "h6">Confirm Reassignment</Typography>
                        <Typography sx = {{ mt: 2 }}>
                            This action will reassign trip <strong>{currentTripId}</strong> from user <strong>{currentUserId}</strong> to user <strong>{userId}</strong>.<br/>
                            Are you sure you want to proceed?
                        </Typography>
                    </React.Fragment>
                )}
                <Box sx = {{ mt: 3, display: "flex", justifyContent: "space-between" }}>
                    <Button
                        variant = "contained"
                        color = "primary"
                        onClick = {handlePrimaryAction}
                        disabled = {!userId && !confirmStep}
                    >
                        {DELETE_CONFIRMATION_YES}
                    </Button>
                    <Button variant = "outlined" onClick = {handleClose}>
                        {DELETE_CONFIRMATION_NO}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default ReassignConfirmationModal;
